const alertLabels = {
  OrderAlreadyReturnedFailure: {
    title: "returns.errors.orderAlreadyReturned.title",
    message: "returns.errors.orderAlreadyReturned.message",
    type: "info"
  },
  OrderNotReturnableAnymoreFailure: {
    title: "returns.errors.orderNotReturnableAnymore.title",
    message: "returns.errors.orderNotReturnableAnymore.message",
    type: "error"
  },
  OrderNotReturnableYetFailure: {
    title: "returns.errors.orderNotReturnableYet.title",
    message: "returns.errors.orderNotReturnableYet.message",
    type: "info"
  },
  OrderNotReturnableFailure: {
    title: "returns.errors.orderNotReturnable.title",
    message: "returns.errors.orderNotReturnable.message",
    type: "error"
  },
  OrderNotFoundFailure: {
    title: "returns.errors.orderNotFoundFailure.title",
    message: "returns.errors.orderNotFoundFailure.message",
    type: "error"
  },
  ReturnGeneralFailure: {
    title: "returns.errors.returnGeneralFailure.title",
    message: "returns.errors.returnGeneralFailure.message",
    type: "error"
  },
  ReturnInputInvalidFailure: {
    title: "returns.errors.returnInputInvalidFailure.title",
    message: "returns.errors.returnInputInvalidFailure.message",
    type: "error"
  },
  OrderReturnAlreadyRequestedFailure: {
    title: "returns.errors.orderReturnAlreadyRequestedFailure.title",
    message: "returns.errors.orderReturnAlreadyRequestedFailure.message",
    type: "info"
  }
};
export {
  alertLabels
};
//# sourceMappingURL=index.js.map
